import { AgreementTypeEnum } from "__generated__/enums";
import { hasPluginPermission } from "components/utils/Permission";
import ezStore, { Session } from "ezStore";

const NEGATIVE_COMMISSION_AGREEMENT_TYPES: AgreementTypeEnum[] = [
	AgreementTypeEnum.Commission,
	AgreementTypeEnum.AddressCommission,
];

export const hasNegativePercentage = (
	agreementType?: AgreementTypeEnum | null,
	session: Session = ezStore.getState().session,
) => !!agreementType
	&& NEGATIVE_COMMISSION_AGREEMENT_TYPES.includes(agreementType)
	&& hasPluginPermission(session, "defaultNegativeCommissionPercentage");
